import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Color from '../../../enums/color';
const StyledSectionHeader = styled.div `
  position: relative;
  padding: 16px 32px;
  color: ${Color.White};
  background: ${Color.ElectricBlue};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  border-bottom: 1px solid ${Color.White};
  font-family: Roboto Medium;
`;
const SectionHeader = ({ title }) => {
    const { t: translate } = useTranslation();
    return <StyledSectionHeader>{translate(title)}</StyledSectionHeader>;
};
export default SectionHeader;
